import { Injectable, Injector } from '@angular/core';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { ModalAction, ModalOptions, ModalResponse } from '../modal/modal.model';
import { ModalService } from '../modal/modal.service';
import { FormComponent } from './form.component';
import { FormModel } from './form.model';
import { FieldFormValue } from './field-form.directive';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  isPendingChangesDialogOpen = false;
  isFieldEditActive = false;
  isInlineEditActive = false;
  isModalEditActive = false;

  constructor(private _modalService: ModalService) {}

  openFormModal(
    model: FormModel,
    title: string,
    injector?: Injector,
    modalOptions?: ModalOptions
  ) {
    return this._modalService
      .buildModal()
      .withTitle(title)
      .withComponentBody({
        component: FormComponent,
        props: {
          model,
        },
        injector,
      })
      .open({ size: modalOptions?.size, isTable: modalOptions?.isTable })
      .pipe(
        mergeMap(this.submitFormModal),
        catchError(() => EMPTY)
      );
  }

  openFieldModal(
    model: FormModel,
    injector: Injector,
    title?: string,
    modalOptions?: ModalOptions
  ): Observable<FieldFormValue> {
    return this.openFormModal(model, title, injector, modalOptions);
  }

  openPendingChangesDialog() {
    this.isPendingChangesDialogOpen = true;

    return this._modalService
      .buildModal()
      .withTitle('forms.validation.pendingChangesDialog.title')
      .withTextBody('forms.validation.pendingChangesDialog.body', {
        textAlign: 'center',
      })
      .open({ closeWithEscape: false })
      .pipe(
        tap((response) => {
          this.isPendingChangesDialogOpen = false;
          response.modalRef.close();
        })
      );
  }

  closeModals() {
    this._modalService.closeModals();
  }

  submitFormModal = (response: ModalResponse<FormComponent>) => {
    if (response.action === ModalAction.Close) {
      return throwError(null);
    }

    const formValue = response.componentRef.submit();

    if (!formValue) {
      return EMPTY;
    }

    response.modalRef.close();
    return of(formValue);
  };
}
